<template>
  <div class="hazmat-checkbox">
    <Checkbox
      :binary="true"
      v-model="isHazmat"
      @change="checkboxHandling"
      :disabled="updatingRequestInProcess"
    />
    <span v-if="hazmatInfoFilled">
      <i @click="openHazmatModal()" class="ion ion-create-outline"></i>
    </span>
    <b-modal
      v-model="showHazmatModal"
      hide-header
      hide-footer
      size="lg"
      no-close-on-backdrop
      centered
      lazy
      @hide="closeHazmatModal"
    >
      <HazmatModal
        v-model="hazmatData"
        :hazmatData="hazmatData"
        :saving="savingHazmat"
        @closeModal="closeHazmatModal"
        @saveHazmatInformation="saveHazmatInformation($event)"
        ref="hazmat-modal"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Checkbox from "primevue/checkbox";
import { errorMessage } from "../../../../../../utils/ErrorMessages";
import HazmatModal from "./HazmatModal.vue";

export default {
  /* eslint-disable operator-linebreak */
  name: "HazmatCheckbox",
  props: {
    hazmatIndex: Number,
    itemIsHazmat: Boolean,
    hazmat: Object,
    lineItems: Array,
  },
  components: {
    Checkbox,
    HazmatModal,
  },
  data() {
    return {
      isHazmat: false,
      showHazmatModal: false,
      hazmatData: null,
      loadId: null,
      hazmatInfoFilled: false,
      savingHazmat: false,
    };
  },
  created() {
    this.loadId = this.$route.params.loadId;
    this.hazmatData = { ...this.hazmat };
    const hazmatFieldsInfo = this.checkIfHazmatIsFilled();
    if (this.itemIsHazmat && hazmatFieldsInfo) {
      this.isHazmat = true;
    }
  },
  computed: {
    ...mapGetters({
      chosenLoad: "load/getChosenLoad",
      updatingRequestInProcess: "load/tender/getRequestInProcess",
    }),
    locationId() {
      return this.chosenLoad?.stops?.find((stop) => stop.is_pickup)?.location_id ?? null;
    },
  },
  watch: {
    hazmatData: {
      deep: true,
      immediate: true,
      handler() {
        this.hazmatInfoFilled = this.checkIfHazmatIsFilled();
      },
    },
    hazmat: {
      handler() {
        this.hazmatData = { ...this.hazmat.hazmat };
        this.isHazmat = this.checkIfHazmatIsFilled();
      },
    },
  },
  methods: {
    checkIfHazmatIsFilled() {
      let alInformationIsFilled = true;
      if (this.hazmatData) {
        Object.keys(this.hazmatData).forEach((key) => {
          if (!this.hazmatData[key]) {
            alInformationIsFilled = false;
          }
        });
      } else {
        alInformationIsFilled = false;
      }
      this.hazmatInfoFilled = alInformationIsFilled;
      return alInformationIsFilled;
    },
    async checkboxHandling() {
      if (!this.isHazmat) {
        const payload = {};
        if (this.hazmatData) {
          Object.keys(this.hazmatData).forEach((key) => {
            payload[key] = key === "hazardous_materials" ? false : "";
          });
          this.hazmatData = {};
        }
        this.$emit("removeHazmatInformation", payload, this.hazmatIndex);
        return;
      }
      this.openHazmatModal();
    },
    openHazmatModal() {
      if (!this.updatingRequestInProcess) {
        this.hazmatData = { ...this.hazmat.hazmat };
        this.showHazmatModal = true;
      }
    },
    closeHazmatModal() {
      if (!this.checkIfHazmatIsFilled()) {
        this.isHazmat = false;
        this.hazmatData = null;
      }
      this.showHazmatModal = false;
    },
    async saveHazmatInformation(event) {
      const {
        hazmatData,
        hazmatContact,
        contactHasChanged,
      } = event;
      this.savingHazmat = true;
      const hazmatContactId = await this.saveHazmatContact(
        hazmatData,
        hazmatContact,
        contactHasChanged
      );
      if (!hazmatContactId) {
        this.savingHazmat = false;
        return;
      }
      this.$emit("addHazmatInformation", {
        ...hazmatData,
        hazmat_contact: hazmatContactId,
      }, this.hazmatIndex, true);
      this.showHazmatModal = false;
      this.savingHazmat = false;
    },
    async saveHazmatContact(hazmatData, hazmatContact, contactHasChanged) {
      const dataContact = {
        first_name: hazmatContact.first_name,
        last_name: hazmatContact.last_name,
        phone: hazmatContact.phone,
        email: hazmatContact.email,
      };
      const currentContactId = hazmatData.hazmat_contact?.id || hazmatData.hazmat_contact;
      if (currentContactId === process.env.VUE_APP_HAZMAT_ID_DEV) {
        if (contactHasChanged) {
          if (!this.locationId) {
            errorMessage("Missing pickup stop information to associate the contact.");
            return null;
          }
          dataContact.account_id = this.locationId;
          const response = await this.$store.dispatch("load/stops/createSalesforceContacts", dataContact);
          if (response) {
            return response.id;
          }
        }
        return currentContactId;
      }
      if (contactHasChanged) {
        const payload = {
          body: dataContact,
          id: hazmatContact.id
        };
        await this.$store.dispatch("load/stops/updateSalesforceContact", payload);
      }
      return currentContactId;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;

.hazmat-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    margin-left: 7px;
    color: #7a7a7a;
  }
  i {
    cursor: pointer;
    color: $color-border-container;
    font-size: 19px;
  }
}
.is-active {
  margin-left: 30px;
}
::v-deep .p-checkbox .p-checkbox-box {
  padding: 10px;
  border-radius: 6px;
  border: 1px solid $color-border-container;
}
::v-deep .p-checkbox .p-checkbox-box.p-highlight {
  background: $color-primary-trigger-button;
  border-color: $color-border-container;
  &:hover {
    background: $color-border-container;
    background-color: $color-border-container;
    border-color: $color-border-container;
  }
}
::v-deep .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus {
  border-color: $color-border-container;
  box-shadow: none;
}
::v-deep .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
  border-color: $color-border-container;
}
::v-deep .floatlabel-input {
  border: 1px solid $color-border-container;
}
::v-deep .modal-content {
  width: 55% !important;
  margin: auto;
  @media (max-width: 798px) {
    width: 80% !important;
  }
}
// modal styles
::v-deep .modal-content {
  border-radius: 10px;
  background-color: $color-gray-light;
}
::v-deep .modal-body {
  padding: 0;
  border-radius: 10px;
}
</style>
